import { Col, Row } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import Map from '../components/GoogleMaps/Maps';
import { getCookieConsentValue } from "react-cookie-consent";
import Fullwidth from '../components/Layout/Fullwidth';
import Kachel from '../components/kachel';


function Kontakt() {
    const Maps = () => {
        if(getCookieConsentValue("heinrich-heiden.de")) {
            return (
                <Map />
                )
        }
        return <p>no map</p>;
    }
  return (
    <div>
         <Row>
            <Col className="page-header">
                <h1>So erreichen Sie uns!</h1>
            </Col>
        </Row>
        <Row className='page-main page-contact'>
            <Fullwidth>
                <div className='row'>
                    <Col className='man-map'>
                        <Maps />
                    </Col>                    
                </div>
                <Row>
                    <Col xs={12} md={4} className='bg-red'>
                        <Kachel icon='/man_icon_network.svg'>
                           <h3 className='text-center'>
                            Heinrich GmbH & Co.KG<br/>
                            Schüllsmühle 14<br/>
                            52353 Düren 
                           </h3>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-white'>
                        <Kachel icon='/man_icon_kontakt.svg' bgColor={"red"}>
                            <h4 className='text-center'>
                                <span className='highlight-text'>Tel</span> <a className="text-decoration-none" href="tel:+49242198750">02421 98750</a><br />
                                <span className='highlight-text'>Fax</span> <a className="text-decoration-none" href="fax:+492421880689">02421 880689</a>
                            </h4>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-red'>
                        <Kachel icon='/man_icon_mail.svg'>
                            <h4 className='text-center'>
                                <a style={{color: 'white'}} href="mailto:info@heinrich-heiden.de">info@heinrich-heiden.de</a>
                            </h4>
                        </Kachel>
                    </Col>
                </Row>
            </Fullwidth>
          
        </Row>
    </div>
  );
}

export default Kontakt;